import CustomDialog from './src/customDialog.vue'

export default {
    install: (Vue) => {
        Vue.component(CustomDialog.name, CustomDialog);
    }
}


// WEBPACK FOOTER //
// ./src/components/customDialog/index.js